__webpack_require__.p = "/XING-frontend/";